<template>
  <div class="table-tab">
    <div class="admin-buy__block-gui-btn a-flex-start u-margin-b-24">
      <button class="gui-btn gui-btn--red" type="button" @click="onDownloadSpecClick">
        {{$t('buttons.download-specification')}}
      </button>
      <file-picker accept="csv"
                   :label="'buttons.upload-specification'"
                   :signing="false"
                   @prepared="onFileSelected"
                   v-if="canEditSpecification">
      </file-picker>
    </div>

    <base-specification-table :specs="specs"
                              :number-of-parts="retend.numberOfParts"
                              :editable="canEditSpecification"
                              :lot-catalog="retend.lot"
                              @update="onSpecificationUpdate"></base-specification-table>

    <loading v-if="loading"></loading>
  </div>
</template>

<script>
  import CommonMixins from '../mixins/common'
  import PermissionsMixins from '../mixins/permissions'
  import BaseSpecificationTable from "../common/base-SpecificationTable";

  export default {
    components: {
      BaseSpecificationTable
    },

    props: {
      lot: {
        type: Object,
        required: true
      },

      retend: {
        type: Object,
        required: true
      }
    },

    mixins: [
      CommonMixins,
      PermissionsMixins
    ],

    computed: {
      specs() {
        return this.retend.specs;
      },

      canEditSpecification() {
        return this.canEditRetend;
      },

      bidRules: {
        get() {
          return this.$store.getters.organizationBidRules;
        }
      }
    },

    mounted() {
    },

    methods: {
      async onDownloadSpecClick() {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('exportBidSpecification', {
              requestId: this.lot.request.id,
              bidId: this.bid.id,
              filename: `${this.lot.catalog.name}-${this.lot.request.id}-${this.bid.num}-specification`
            });
          }
          catch(e) {
            console.error('failed download of bid specification', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async onApproveAdditionalSpecItemClick(item) {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('approveAdditionalSpecItem', {
              requestId: this.lot.request.id,
              bidId: this.bid.id,
              position: item.position,
              approved: item.state.valueOf() === this.enums.AdditionalSpecItemState.APPROVED,
              reason: item.reason
            });
          }
          catch(e) {
            console.error('failed download of bid specification', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async onFileSelected(file) {
        try {
          await this.$store.dispatch('uploadBidSpecification', {
            lotId: this.lot.id,
            requestId: this.lot.request.id,
            bidId: this.bid.id,
            file
          });

          await this.saveForm();
        }
        catch(e) {
          console.error('failed upload of bid specification', e);
          this.globalErrorHandler(e);
        }
      },

      onPercentChange(item) {
        item.count = item.percent ? 10000 : 0;
      },

      onSpecificationUpdate(specs) {
        this.retend.specs = specs;
        this.saveForm();
      }
    }
  }
</script>

<style scoped>

</style>
